import React from "react";
import { Link } from "react-router-dom";

export default function Sites() {
    
    return(
        <div className="container">
            <div className="home-container">
                <h1>САЙТЫ ПРОЕКТА RAYTOLFAS</h1>
            </div>

            <div className="content-container">
                <img src="/gradient1.png" alt="Скоро" className="sckoro-img" />
                <h1>Скоро...</h1>
                <Link className="Link-button-header" to="/">На главную</Link>
            </div>
        </div>
    )
}